import { createSelector } from 'reselect';
import { State } from '../../types/mx/reducers';
import {EMPTY_CATALOG} from '../../constants/GlobalConstants';

export const billingTypeSelector = createSelector(
    (state: State) => state.catalogs.employmentBillingTypes,
    (state: State) => state.creditoReal.loanApplication.applicantEmployment.billingTypeId,
    (billingTypes, billingTypeId) =>
        billingTypes?.find(i => i.id === billingTypeId) || EMPTY_CATALOG
);

export const taxRegimeSelector = createSelector(
    (state: State) => state.catalogs.employmentTaxRegimes,
    (state: State) => state.creditoReal.loanApplication.applicantEmployment.taxRegimeId,
    (taxRegimes, taxRegimeId) =>
        taxRegimes?.find(i => i.id === taxRegimeId) || EMPTY_CATALOG
);
